import { render, staticRenderFns } from "./OrgItems.vue?vue&type=template&id=7b9c3e92&scoped=true"
import script from "./OrgItems.vue?vue&type=script&lang=js"
export * from "./OrgItems.vue?vue&type=script&lang=js"
import style0 from "./OrgItems.vue?vue&type=style&index=0&id=7b9c3e92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9c3e92",
  null
  
)

export default component.exports